export default "__VITE_ASSET__qoJJEOjl__"